import { render, staticRenderFns } from "./importMerchantManage.vue?vue&type=template&id=688b34df&scoped=true&"
import script from "./importMerchantManage.vue?vue&type=script&lang=js&"
export * from "./importMerchantManage.vue?vue&type=script&lang=js&"
import style0 from "./importMerchantManage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./importMerchantManage.vue?vue&type=style&index=1&id=688b34df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688b34df",
  null
  
)

component.options.__file = "importMerchantManage.vue"
export default component.exports